import React, {useContext, useEffect, useState} from 'react';
import {useQuery} from '@tanstack/react-query';
import {BillInterface} from '../../interfaces/customer/BillInterface';
import {orderList} from '../../api/customer';
import {CustomerInterface} from '../../interfaces/customer/CustomerInterface';
import {CustomerManagerInterface} from '../../interfaces/customer/CustomerManagerInterface';
import {ReducerStateInterface} from "../../interfaces/core/ReducerStateInterface";
import {GlobalContext} from "../../GlobalReducer";
import Money from "../core/Money";
import MoneyInterface from "../../interfaces/core/MoneyInterface";
import {formatDate, formatNumber} from "../../utils/Utils";
import {Link} from "react-router-dom";

export default function OrderList() {
    const [expandedOrders, setExpandedOrders] = useState<Set<string>>(new Set());
    const [state,] = useContext<[ReducerStateInterface, Function]>(GlobalContext);

    const {data: orders, isLoading} = useQuery({
        queryKey: ['orders'],
        queryFn: () => orderList( state.customer as CustomerInterface, state.manager as CustomerManagerInterface ),
        //@ts-ignore
        retry: !window.NOSCRIPT ? false : 1,
        enabled: !!state.customer
    });

    const toggleBills = (orderId: string) => {
        setExpandedOrders(prev => {
            const newSet = new Set(prev);
            if (newSet.has(orderId)) {
                newSet.delete(orderId);
            } else {
                newSet.add(orderId);
            }
            return newSet;
        });
    };

    const getBillStatusLabel = (bill: BillInterface) => {
        if (bill.status_id === 1) {
            return <span className="text-success me-1" title={`счет ${bill.bill_id}, согласован`}>c</span>;
        }
        return <span className="text-danger mx-1" title={`счет ${bill.bill_id}, не согласован`}>н</span>;
    };

    return (
        <div >
            <h3>Список заказов ({orders?.length})</h3>
                {isLoading && (
                    <div className="text-center">
                        <i className="fa fa-spinner fa-spin"></i> Загрузка...
                    </div>
                )}

                {!isLoading && orders && orders.length === 0 && (
                    <div className="alert alert-warning alert-dismissible">
                        <h4><i className="icon fa fa-info"></i> Информация</h4>
                        У Вас пока нет ни одного заказа
                    </div>
                )}

                {!isLoading && orders && orders.length > 0 && (
                    <div className="table-responsive">
                        <table className="table table-striped">
                            <thead>
                            <tr>
                                <th>№</th>
                                <th>Оформлен</th>
                                {/*<th>Грузополучатель</th>*/}
                                <th>Сумма</th>
                                <th>Вес, кг.</th>
                                <th>Объем, м<sup>3</sup></th>
                                <th>Счетов</th>
                                <th>Статус</th>
                                <th>Комментарий</th>
                            </tr>
                            </thead>
                            <tbody>
                            {orders.map((order) => (
                                <React.Fragment key={order.order_id}>
                                    <tr className={order.status_id === '100' ? 'bg-danger' : ''}>
                                        <td>
                                            <Link className={'text-decoration-underline'} to={`/account/order/${order.order_id}`}>{order.order_id}</Link>
                                        </td>
                                        <td>{formatDate(order.create_date)}</td>
                                        {/*<td>{order.consignee_name}</td>*/}
                                        <td>
                                            <span className={'text-nowrap'}>
                                            <Money value={order.total}/>
                                            </span>
                                        </td>
                                        <td>
                                            {order.bill_weight ? (
                                                <span title={order.weight}>{order.bill_weight}</span>
                                            ) : (
                                                <span>{order.weight}</span>
                                            )}
                                        </td>
                                        <td>
                                            {order.bill_volume ? (
                                                <span title={order.volume}>{formatNumber(order.bill_volume)}</span>
                                            ) : (
                                                <span>{formatNumber(order.volume)}</span>
                                            )}
                                        </td>
                                        <td>
                                            {order.bills.length > 0 ? (
                                                <>
                                                    <span className={'pointer t-orange'}
                                                        onClick={() => toggleBills(order.order_id)}
                                                    >
                                                        {order.bills.length}
                                                    </span>
                                                    {' '}
                                                    {order.bills.map((bill) => (
                                                        <React.Fragment key={bill.id}>
                                                            {getBillStatusLabel(bill)}
                                                        </React.Fragment>
                                                    ))}
                                                </>
                                            ) : (
                                                <span>0</span>
                                            )}
                                        </td>
                                        {/*<td>{order.message_count || 0}</td>*/}
                                        <td>
                                                <span className={`badge bg-${order.status_label.replace(/default/, 'secondary') || 'secondary'}`}>
                                                    {order.status_name}
                                                </span>
                                        </td>
                                        {/*{order.customer_managers?.map((manager, index) => (*/}
                                        {/*    <div key={index} className="font-size-90">*/}
                                        {/*        {manager.name}*/}
                                        {/*    </div>*/}
                                        {/*))}*/}

                                        <td>{order.comment}</td>
                                    </tr>
                                    {order.bills.length > 0 && expandedOrders.has(order.order_id) && (
                                        <tr>
                                            <td colSpan={11}>
                                                <table className="table table-condensed table-striped border border-4" style={{marginBottom: 0}}>
                                                    <thead>
                                                    <tr>
                                                        <th>№</th>
                                                        <th>Создан</th>
                                                        <th>Позиций</th>
                                                        <th>Сумма</th>
                                                        <th>Вес, кг.</th>
                                                        <th>Объем, м<sup>3</sup></th>
                                                        <th>Статус</th>
                                                    </tr>
                                                    </thead>
                                                    <tbody>
                                                    {order.bills.map((bill) => (
                                                        <tr key={bill.id}>
                                                            <td>{bill.bill_id}</td>
                                                            <td>{formatDate(bill.create_date)}</td>
                                                            <td>
                                                                <span
                                                                    className={'text-nowrap'}>{bill.bill_cnt} шт.</span>
                                                            </td>
                                                            <td>
                                                                <span
                                                                    className={'text-nowrap'}><Money value={bill.bill_total as MoneyInterface} /></span>
                                                            </td>
                                                            <td>{bill.bill_weight}</td>
                                                            <td>{formatNumber(bill.bill_volume || 0)}</td>
                                                            <td>
                                                                {bill.status_id === 0 && (
                                                                    <span
                                                                        className="badge bg-secondary">не согласован</span>
                                                                )}
                                                                {bill.status_id === 1 && (
                                                                    <span
                                                                        className="badge bg-success">согласован</span>
                                                                )}
                                                            </td>
                                                        </tr>
                                                    ))}
                                                    </tbody>
                                                </table>
                                            </td>
                                        </tr>
                                    )}
                                </React.Fragment>
                            ))}
                            </tbody>
                        </table>
                    </div>
                )}
        </div>
    );
}